import { makeStyles } from '@material-ui/core';
import * as React from 'react';
import { useEffect } from 'react';
import { AutocompleteInput, Filter, ReferenceInput, TextInput, useListContext, useTranslate } from 'react-admin';
import { GROUP_METADATA_AVATAR_TYPES, METADATA_AVATAR_TYPES } from '../../../providers/resources';
import { getNameWithoutPrefixFromJson as getGroupMetadataAvatarTypeNameWithoutPrefixFromJson } from '../../../utils/resources/GroupMetadataAvatarType';
import { getNameWithoutPrefixFromJson } from '../../../utils/resources/MetadataAvatarType';
import PeriodInputEmptying from './PeriodInputEmptying';
import PeriodInputInstallationDate from './PeriodInputInstallationDate';
import PeriodInputMaintenance from './PeriodInputMaintenance';
import ThresholdNameSelectInput from './ThresholdNameSelectInput1';
import StatusFilter from './StatusFilter';
import DepartmentFilterInput from './DepartmentFilterInput';

const styles = () => ({
    form: {
        marginLeft: 0,
        display: 'flex',
        flexWrap: 'wrap' as const,
        alignItems: 'flex-end' as const,
        gap: 16,
    },
});

const useStyles = makeStyles(styles);

const SimpleListFilter = (props: any) => {
    const t = useTranslate();
    const classes = useStyles();

    const { setFilters, displayedFilters, filterValues } = useListContext();

    useEffect(() => {
        if (!('productInstallationDate' in displayedFilters)) {
            let newFilters = { ...filterValues };
            if ('productInstallationDate__after' in newFilters || 'productInstallationDate__before' in newFilters) {
                delete newFilters['productInstallationDate__after'];
                delete newFilters['productInstallationDate__before'];
                setFilters(newFilters, displayedFilters);
            }
        }

        if (!('note_v0' in displayedFilters)) {
            let newFilters = { ...filterValues };
            if (
                'note_v0__createdAt_after' in newFilters ||
                'note_v0__createdAt_before' in newFilters ||
                'note_v0__tags' in newFilters
            ) {
                delete newFilters['note_v0__createdAt_after'];
                delete newFilters['note_v0__createdAt_before'];
                delete newFilters['note_v0__tags'];
                setFilters(newFilters, displayedFilters);
            }
        }

        if (!('productLastEmptyingDate' in displayedFilters)) {
            let newFilters = { ...filterValues };
            if ('productLastEmptyingDate__after' in newFilters || 'productLastEmptyingDate__before' in newFilters) {
                delete newFilters['productLastEmptyingDate__after'];
                delete newFilters['productLastEmptyingDate__before'];
                setFilters(newFilters, displayedFilters);
            }
        }

        if (!('productLastMaintenanceDate' in displayedFilters)) {
            let newFilters = { ...filterValues };
            if (
                'productLastMaintenanceDate__after' in newFilters ||
                'productLastMaintenanceDate__before' in newFilters
            ) {
                delete newFilters['productLastMaintenanceDate__after'];
                delete newFilters['productLastMaintenanceDate__before'];
                setFilters(newFilters, displayedFilters);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayedFilters]);

    return (
        <Filter
            {...props}
            classes={{
                form: classes.form,
            }}
        >
            <StatusFilter
                className='firstInput'
                alwaysOn={true}
                source='productCurrentStatusName'
                label={t('app.ancs.nodeStateName')}
            />

            <DepartmentFilterInput source='department' alwaysOn={true} />

            <TextInput
                size={'small'}
                variant={'standard'}
                label={t('app.ancs.serialNumber')}
                source='productSerialNumber'
                alwaysOn={false}
                InputLabelProps={{ shrink: true }}
            />

            <PeriodInputInstallationDate source='productInstallationDate' label={t('app.ancs.installingDate')} />
            {/*<ProductTypeNameReferenceInput />*/}
            <ReferenceInput
                size={'medium'}
                variant={'standard'}
                label={t('app.ancs.name')}
                // source='productTypeName'
                source='metadataAvatarTypeId'
                reference={METADATA_AVATAR_TYPES}
                alwaysOn={false}
                filterToQuery={(searchText) => ({ name: searchText })}
            >
                <AutocompleteInput optionText={getNameWithoutPrefixFromJson} />
                {/*<AutocompleteIdInput />*/}
            </ReferenceInput>

            <ReferenceInput
                size={'medium'}
                variant={'standard'}
                label={t('app.ancs.productTypology')}
                source='groupMetadataAvatarTypeId'
                reference={GROUP_METADATA_AVATAR_TYPES}
                alwaysOn={false}
                filterToQuery={(searchText) => ({ name: searchText })}
            >
                <AutocompleteInput optionText={getGroupMetadataAvatarTypeNameWithoutPrefixFromJson} />
            </ReferenceInput>

            <PeriodInputEmptying
                source='productLastEmptyingDate'
                label={t('app.ancs.sludgeEmptyingThresholdFilterLastDate')}
            />

            <PeriodInputMaintenance
                source='productLastMaintenanceDate'
                label={t('app.ancs.sludgeMaintenanceThresholdFilterLastDate')}
            />

            <ThresholdNameSelectInput
                // source={encodeURI(`${props.source}[customFieldsThresholdName]`)}
                source={'productLastMaintenanceThresholdName'}
                label={t('app.traceabilityNotesThreshold.maintenance.name')}
            />

            <ThresholdNameSelectInput
                // source={encodeURI(`${props.source}[customFieldsThresholdName]`)}
                source={'productLastEmptyingThresholdName'}
                label={t('app.traceabilityNotesThreshold.emptying.name')}
            />
            {/*{userConnected && (*/}
            {/*    <ReferenceInput*/}
            {/*        filter={{*/}
            {/*            isDeployed: true,*/}
            {/*            companyId: userConnected?.company.id,*/}
            {/*        }}*/}
            {/*        size={'medium'}*/}
            {/*        variant={'standard'}*/}
            {/*        label={t('app.ancs.nodeStateName')}*/}
            {/*        source='currentNode.name'*/}
            {/*        reference={RUNNER_TEMPLATES}*/}
            {/*        alwaysOn={true}*/}
            {/*    >*/}
            {/*        <CustomAutocompleteInputCurrentNode id={'customAutocompleteInputCurrentNode'} />*/}
            {/*    </ReferenceInput>*/}
            {/*)}*/}
            {/* @ts-ignore */}
        </Filter>
    );
};
export default SimpleListFilter;
